/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EVENT_CALENDAR_REPORT,
  LOAD_EVENT_CALENDAR_REPORT_SUCCESS,
  LOAD_EVENT_CALENDAR_REPORT_ERROR,
  LOAD_EVENT_DETAILS_CALENDAR_REPORT_SUCCESS,
  LOAD_EVENT_DETAILS_CALENDAR_REPORT_ERROR,
  LOAD_EVENT_DETAILS_CALENDAR_REPORT,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(calendarMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    calendarMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Calendar Report
export function loadEventCalendarReportList(searchValue) {
  return {
    type: LOAD_EVENT_CALENDAR_REPORT,
    searchValue,
  }
}
export function loadEventCalendarReportListSuccess(calendar_report) {
  return {
    type: LOAD_EVENT_CALENDAR_REPORT_SUCCESS,
    calendar_report,
  }
}
export function loadEventCalendarReportListError(error) {
  return {
    type: LOAD_EVENT_CALENDAR_REPORT_ERROR,
    error,
  }
}
//Calendar Event details Report
export function loadEventDetailsCalendar(searchValue) {
  return {
    type: LOAD_EVENT_DETAILS_CALENDAR_REPORT,
    searchValue,
  }
}
export function loadEventDetailsCalendarSuccess(
  event_calendar_report,
  success
) {
  console.log(event_calendar_report, "event calendar report")
  return {
    type: LOAD_EVENT_DETAILS_CALENDAR_REPORT_SUCCESS,
    event_calendar_report,
    success,
  }
}
export function loadEventDetailsCalendarError(error) {
  return {
    type: LOAD_EVENT_DETAILS_CALENDAR_REPORT_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEventCalendarReportList,
  loadEventCalendarReportListSuccess,
  loadEventCalendarReportListError,

  loadEventDetailsCalendar,
  loadEventDetailsCalendarSuccess,
  loadEventDetailsCalendarError,
}

export default actions
